import { render, staticRenderFns } from "./CreditClassBulkSave.vue?vue&type=template&id=da0766ec&"
import script from "./CreditClassBulkSave.vue?vue&type=script&lang=js&"
export * from "./CreditClassBulkSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports